import React from 'react';
import { Box } from '@mui/material';

const SubmitButtonWrapper = ({ children, ...props }) => {
  return (
    <Box
      sx={(theme) => ({
        background: '#fff',
        position: { xs: 'fixed', sm: 'unset' },
        bottom: 0,
        width: '100%',
        left: 0,
        py: 2,
        px: { xs: 3, sm: 2 },
        boxShadow: theme.shadows[25],
        borderTop: { xs: `1px solid ${theme.palette.divider}`, sm: 'unset' },
        zIndex: 1,
      })}
      {...props}
      data-testid="save-btn-wrapper"
    >
      <Box pr={0}>{children}</Box>
    </Box>
  );
};

export default SubmitButtonWrapper;
